import { type FunctionComponent } from 'react';
import { Cell, HStack, Stub, StubCell } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';

export type CellVariantNameStubProps = TestProps;

export const CellVariantNameStub: FunctionComponent<CellVariantNameStubProps> = ({
    'data-testid': dataTestId = 'CellVariantNameStub',
}) => (
    <HStack data-testid={dataTestId} gap="16">
        <Cell type="Image" isGrowable={false} rightPadding={false}>
            <Stub height={52} width={52} />
        </Cell>
        <StubCell isGrowable withCaption />
    </HStack>
);
